import logger from 'Utils/Logger';

export const debugReducer = (
  state: Record<string, unknown> = {},
  action: { type: string; [key: string]: unknown },
) => {
  logger.debug(action);
  return state;
};
